import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getAdminDashTopCards } from "../../api/Dashboard/getAdminDashTopCards";
import Preloader from "../common/Preloader";

const AdminDashTopCards = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [adminDashTopCardCounts, setAdminDashTopCardCounts] = useState(null);
    const [showPreloader, setShowPreloader] = useState(false);

    const fetchDashboardData = async () => {
        try {
            setShowPreloader(true);
            const data = await getAdminDashTopCards(user.user.token);
            setAdminDashTopCardCounts(data);
        } catch (error) {
            console.error("Failed to fetch admin dashboard data:", error);
            toast.error("Failed to fetch data. Please try again.");
        } finally {
            setShowPreloader(false);
        }
    };

    useEffect(() => {
        if (!(user && user.user.token)) {
            navigate("/login");
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }

        // Initial fetch
        fetchDashboardData();

        // Set up interval for refreshing data every 5 minutes
        const intervalId = setInterval(fetchDashboardData, 300000); // 5 minutes = 300,000 ms

        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, [user, navigate]);

    return (
        <>
            <div className="row gutters">
                <Preloader show={showPreloader} />
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="info-stats4">
                        <div className="info-icon">
                            <i className="icon-gift"></i>
                        </div>
                        <div className="sale-num">
                            <h3>{adminDashTopCardCounts?.numberOfOrders ?? "--"}</h3>
                            <p>Number of Orders</p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="info-stats4">
                        <div className="info-icon">
                            <i className="icon-shopping_basket"></i>
                        </div>
                        <div className="sale-num">
                            <h3>
                                {adminDashTopCardCounts
                                    ? adminDashTopCardCounts.crops_NotOrganic +
                                      adminDashTopCardCounts.crops_Organic
                                    : "--"}
                            </h3>
                            <p>
                                Crops: <em>Organic-{adminDashTopCardCounts?.crops_Organic ?? "--"}, Conventional-{adminDashTopCardCounts?.crops_NotOrganic ?? "--"}</em>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="info-stats4">
                        <div className="info-icon">
                            <i className="icon-shopping_basket"></i>
                        </div>
                        <div className="sale-num">
                            <h3>{adminDashTopCardCounts?.numberOfShipments ?? "--"}</h3>
                            <p>Shipments</p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="info-stats4">
                        <div className="info-icon">
                            <i className="icon-format_color_fill"></i>
                        </div>
                        <div className="sale-num">
                            <h3>{adminDashTopCardCounts?.numberOfSpoilages ?? "--"}</h3>
                            <p>Spoilages</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminDashTopCards;
